import type { Scope } from '@govard/tenant-core';
import type { OpenRouterChatModelId } from '@govard/llm-gate-client';

import { useEntityChat, type EntityChatAgent } from './useEntityChat.js';
import type { LlmGatewayProfile } from '../api/chat.client.js';

export function useDealChat(
  scope: Scope | null,
  dealId: string,
  selectedConversationId?: string | null,
  openRouterModel?: OpenRouterChatModelId,
  gatewayProfile?: LlmGatewayProfile,
): EntityChatAgent {
  const input = {
    contextEntityType: 'deal',
    contextEntityId: dealId,
    ...(selectedConversationId !== undefined ? { conversationId: selectedConversationId } : {}),
    ...(openRouterModel === undefined ? {} : { openRouterModel }),
    ...(gatewayProfile === undefined ? {} : { gatewayProfile }),
  } as const;

  return useEntityChat(scope, input);
}
